import React, { useState, useRef } from 'react';
import { arquivoParaAnexo } from '../../../FuncoesGerais/anexoArquivo';

function ChamadoAttachmentField({
    nomeArquivo,
    onFileChange,
    id = 'chamado-anexo',
}) {
    const [dragover, setDragover] = useState(false);
    const [erroLocal, setErroLocal] = useState('');
    const inputRef = useRef(null);

    const handleDrop = (e) => {
        e.preventDefault();
        setDragover(false);
        const file = e.dataTransfer?.files?.[0];
        if (file) handleFile(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragover(true);
    };

    const handleDragLeave = () => setDragover(false);

    const handleFile = async (file) => {
        setErroLocal('');
        try {
            const preparado = await arquivoParaAnexo(file);
            onFileChange(preparado);
        } catch (err) {
            onFileChange({ base64: '', nome: '' });
            setErroLocal(err?.message || 'Não foi possível preparar o anexo.');
        }
    };

    const handleInputChange = (e) => {
        const file = e.target?.files?.[0];
        if (file) handleFile(file);
    };

    return (
        <div className="chamado-create-attachment-zone">
            <label htmlFor={id}>Anexo do chamado</label>
            <div
                className={`chamado-create-attachment-drop ${dragover ? 'dragover' : ''}`}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onClick={() => inputRef.current?.click()}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && inputRef.current?.click()}
            >
                <input
                    ref={inputRef}
                    id={id}
                    type="file"
                    onChange={handleInputChange}
                    accept="image/*,.pdf,.doc,.docx"
                />
                Arraste arquivos aqui ou clique para enviar.
            </div>
            {nomeArquivo && (
                <span className="chamado-create-attachment-filename">{nomeArquivo}</span>
            )}
            {erroLocal && (
                <span className="chamado-create-attachment-erro">{erroLocal}</span>
            )}
        </div>
    );
}

export default ChamadoAttachmentField;
